import { Business } from './../../../models/business';
import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr'; // Alert message using NGX toastr
import { FireBusinessAssessmentService } from 'src/app/services/fire-business-assessment-services/fire-business-assessment.service'; 
import {  Router } from '@angular/router'; // ActivatedRoue is used to get the current associated components information.
import { MatDialog } from '@angular/material/dialog';
import { ModalsService } from '../../../modals/modals.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FireActionItemService } from 'src/app/services/fire-action-items/fire-action-item.service';
import * as data from './industryList.json';
import {IndustryList} from '../../../models/industryList';

export var B2Bvalue: boolean;
export var B2Cvalue: boolean;
export var showQ15to17: boolean;


export interface Dropdowns {
  value: number;
  name: string;
}

export interface TotalDropdowns {
  value: number;
  name: string;
  totalValue: number
}

export function resetController(isNoneSelected:any, controllerVal: any, cntlr: any, fullController:any, noneAboveController: any){
  // by: @leonkoech
  //purpose: function resets the form to appropriate values when "none" or equivalent is selected
   
   if(isNoneSelected){
     controllerVal.reset();
     controllerVal.setValue(noneAboveController);
     console.log(controllerVal.value);
   }
   else{
     cntlr = fullController;
   }   
}

@Component({
  selector: 'app-business-assessment',
  templateUrl: './business-assessment.component.html',
  styleUrls: ['./business-assessment.component.scss']
})
export class BusinessAssessmentComponent implements OnInit {

  
  isLinear = false;
  panelOpenState = false;

  public assessmentForm: FormGroup; // Define  assessment form...in other one at the bottom of this list
  disableSelect = new FormControl(false);  
  selectedItems = [];
  hasUnitNumber = false;
  selectedOption: string[] = [];
  public industryCategories: IndustryList[];
  public B2B: boolean = false;
  public B2C: boolean = false;
  public OperatingAgreement: boolean = false;
  public CustomerService: boolean = false;
  public CustomerEngagement: boolean = false;
  public OperatingProductionProcess: boolean = false;
  public TeamHiring: boolean = false;
  public HRRetention: boolean = false;
  public HRHiringPractices: boolean = false;
  public IndustryBarriersOvercome: boolean = false;
  public GeneralIndustryBarriers: boolean = false;
     // "None of the above functionality"
   //      ***** start *****
   public isNonePI6: boolean = false;
   public isNonePI7: boolean = false;
   public isNonePI8: boolean = false;
   public isNoneI1: boolean = false;
   public isNonePI11: boolean = false;
   public isNoneMI7: boolean = false;
  // public isNoneMI8: boolean = false;
   public isNoneB2BTM: boolean = false;
   public isNoneB2CTM: boolean = false;
  // public isNoneMI11: boolean = false;
   public isNoneT2: boolean = false;
   public isNoneTI7: boolean = false;
   //      ****  end  *****
  
   //Industry JSON Variables
  industryCategory: any;
  allIndustryObjects: any;
  singleIndustryObject: any;
  singleIndustrySubCatObject: any;
  industryObjName: any;

  offerType = [
  { name: 'Service' }, 
  { name: 'Product' }, 
  { name: 'Product and Service' }
];
   //define the industry DropDownList data
   //differentiation currently is product and service barriers.
offerIndustryFull = [];
offerIndustrySubcategoryFull = [];

generalIndustryBarriersFull: Dropdowns[] = [//if someone selects Other for Industry
  { value: 1, name: 'Tech Challenges' },
  { value: 1, name: 'Government Regulation (Licensing, permits, etc.)', },
  { value: 1, name: 'Startup costs/Access to capital' },
  { value: 1, name: 'High research and development costs' },
  { value: 1, name: 'Ownership of Raw Materials' },
  { value: 1, name: 'Business Owner Education or Skills' },
  { value: 1, name: 'Personal Network, it`s about who you know' },
  { value: 1, name: 'Selling enough to make money on each (Economies of Scale)' },
  { value: 1, name: 'Network Effect, Sales' },
  { value: 1, name: 'Brand loyalty' },
  { value: 1, name: 'Access to suppliers and distribution channels' },
];
generalIndustryBarriers= this.generalIndustryBarriersFull;

generalBarriersOvercomeFull: Dropdowns[] = [

];
generalBarriersOvercome=this.generalBarriersOvercomeFull;

generalBarriersOvercomeTemp: Dropdowns[] = [
];


industryBarriersOvercomeFull: Dropdowns[] = [
];

industryBarriersFull: any=[];
industryBarriers = this.industryBarriersFull;


industryBarriersOvercome=this.industryBarriersOvercomeFull;


  operationsMethods = [
    {name: 'Brick and mortar location'},
    {name: 'E-commerce'},
    {name: 'Online platform (software, etc.)'},
    {name: 'Third party product placement/retail'},
    {name: 'Mobile operations/Pop up shops/food trucks/vending'},
   ]

   capitalSeeking = [
    { name: 'None' },
    { name: 'I`m not sure how much' },
    { name: 'Less than $10K' }, 
    { name: '$10K-$50K' }, 
    { name: '$50K-$100K' }, 
    { name: '$100K-$250K' }, 
    { name: '$250K+' }
  ];
  
  offerDifferentiationFull: Dropdowns[] = [
    { value: 1, name: 'Quality' },
    { value: 1, name: 'Design' },
    { value: 1, name: 'Service and interactions' },
    { value: 1, name: 'Features and functionalities' },
    { value: 1, name: 'Customization' },
    { value: 1, name: 'Pricing' },
  ];
  offerDifferentiation= this.offerDifferentiationFull;
  offerSupplierPower : Dropdowns[] = [
    { value: 1, name: 'Not at all easy, it would be detrimental' },
    { value: 2, name: 'Moderately easy' },
    { value: 3, name: 'Extremely easy' },
    { value: 3, name: 'I don`t need suppliers' },
  ];
  knownCompetition: Dropdowns[] = [//check values
    { value: 3, name: 'Not many' },
    { value: 2, name: 'A moderate amount' },
    { value: 1, name: 'A lot' },
  ];

 // by @leonkoech
    // created a permanent storage for dropdowns.
    // original should be used as final Value
    // @talphysust should edit values
   

  marketTargetB2BC = [
    {name: 'Business to Business'},
    {name: 'Business to Consumer'}, 
    {name: 'Both'}
  ]
  marketTargetLocation = [
    { name: 'Local, County or Citywide' },
    { name:'Statewide' },
    { name:'Regional' },
    { name:'National' },
    { name:'International' },
  ];

  B2CTargetMarketFull = [
    { value: 1, name:'Stage of life' },
    { value: 1, name:'Location' },
    { value: 1, name:'Religion or belief' },
    { value: 1, name:'Occupation or hobby' },
    { value: 1, name:'Other' },
  ];

  B2CTargetMarket = this.B2CTargetMarketFull;

  B2BTargetMarketFull = [
    { value: 1, name:'Location' },
    { value: 1, name:'Team Size' },
    { value: 1, name:'Industry' },
    { value: 1, name:'Revenue Size' },
    { value: 1, name:'Ownership structure or type' },
    { value: 1, name:'Other' },
  ];

  B2BTargetMarket = this.B2BTargetMarketFull;

// by @leonkoech
    // created a permanent storage for dropdowns.
    // original should be used as final Value
    // @talphysust should edit values
    pmfCompetitorDissatisfactionFull: Dropdowns[] = [ //fix values
    { value: 1, name: 'Quality' },
    { value: 1, name: 'Design' },
    { value: 1, name: 'Service and interactions' },
    { value: 1, name: 'Features and functionalities' },
    { value: 1, name: 'Customization' },
    { value: 1, name: 'Pricing' },
  ];
  pmfCompetitorDissatisfaction=this.pmfCompetitorDissatisfactionFull;

 /*   pmfB2BCompetitorDissatisfactionFull: Dropdowns[] = [ //fix values
    { value: 1, name: 'Quality' },
    { value: 1, name: 'Design' },
    { value: 1, name: 'Service and interactions' },
    { value: 1, name: 'Features and functionalities' },
    { value: 1, name: 'Customization' },
    { value: 1, name: 'Pricing' },
  ];
  pmfB2BCompetitorDissatisfaction=this.pmfB2BCompetitorDissatisfactionFull;

  pmfB2CCompetitorDissatisfactionFull: Dropdowns[] = [ //fix values
  { value: 1, name: 'Quality' },
  { value: 1, name: 'Design' },
  { value: 1, name: 'Service and interactions' },
  { value: 1, name: 'Features and functionalities' },
  { value: 1, name: 'Customization' },
  { value: 1, name: 'Pricing' },
];
pmfB2CCompetitorDissatisfaction=this.pmfB2CCompetitorDissatisfactionFull;*/

marketingBrand: Dropdowns[] = [
  { value: 2, name: 'It`s great' },
  { value: 1, name: 'I`m getting by' },
  { value: 0, name: 'I don`t have a brand' },
]
marketingEffectiveness: Dropdowns[] = [
 { value: 3, name: 'Extremely comfortable' },
 { value: 2, name: 'Kind of comfortable' },
 { value: 1, name: 'Not at all comfortable' },
 { value: 0, name: 'I don`t market' },
]

marketingWebsite: Dropdowns[] = [
   { value: 3, name: 'I have a lot of visitors, and it drives sales' },
   { value: 2, name: 'I have one with alot of visitors, but its not driving sales' },
   { value: 1, name: 'Its not effective, needs work and/or I don`t know how many visitors I have and how it affects sales' },
   { value: 0, name: 'I don`t have a website' },
]

marketingNetworkMaterial: Dropdowns[] = [
  { value: 3, name: 'Yes, it`s good' },
  { value: 2, name: 'Yes, but it needs work' },
  { value: 1, name: 'No' },
  { value: 0, name: 'I don`t network' }
]


marketingSocialMedia: Dropdowns[] = [
  { value: 3, name: 'It`s a major business driver' },
  { value: 2, name: 'It helps build awareness and engage existing customers' },
  { value: 1, name: 'I use it but there is little to no benefit' },
  { value: 0, name: 'I don`t use social media yet' }
]

customerEngagement: Dropdowns[] = [
  { value: 3, name: 'Highly engaged with lots of repeat customers' },
  { value: 2, name: 'Somewhat engaged'},
  { value: 1, name: 'No engagement at all' },
  { value: 0, name: 'I haven`t started providing customer engagement yet' },
] 

customerService: Dropdowns[] = [
  { value: 3, name: 'Consistently excellent' },
  { value: 2, name: 'Most often good' },
  { value: 1, name: 'Needs work' },
  { value: 0, name: 'I haven`t started providing customer service yet' },
] 

busiRegType = [
  {value: 0, name: 'Not registered'},
  {value: 0, name: 'Sole proprietor'},
  {value: 1, name:'Single Member LLC'},
  {value: 1, name: 'Multi Member LLC'},
  {value: 1, name: 'Corp'},
  {value: 1, name: 'S Corp'},
  {value: 1, name: 'C Corp'},
  {value: 1, name: 'B Corp'},
  {value: 1, name: 'Non-profit'},
 ];

legalOpAgreement: Dropdowns[] = [
  { value: 1, name: 'Yes' },
  { value: 0, name: 'No' },
] 

legalDisclaimers : Dropdowns[] = [
  { value: 1, name: 'Yes' },
  { value: 0, name: 'No' },
  { value: 1, name: 'I don`t need them' },
  { value: 0, name: 'I don’t know if I need them'}
]

legalIP : Dropdowns[] = [
   { value: 1, name: 'has patentable or trademarkable content or product(s), and it`s legally protected.' },
   { value: 0, name: 'has patentable or trademarkable content or product(s), but it`s not legally protected.' },
   { value: 1, name: 'doesn`t have patentable or trademarkable content or product(s).' },
]

financePaymentSystem: Dropdowns[] = [
  { value: 1, name: 'Yes, and someone on the team (or I) know(s) how to use it' },
  { value: 0, name: 'Yes, but no one on the team (or I) know(s) how to use it' },
  { value: 0, name: 'No' },
]

financeAccountingSystem: Dropdowns[] = [
  { value: 1, name: 'Yes, and someone on the team (or I) know(s) how to use it'  },
  { value: 0, name: 'Yes, but no one on the team (or I) know(s) how to use it' },
  { value: 0, name: 'No' },
]

  YesNoNotSure: Dropdowns[] = [
    { value: 1, name: 'Yes' },
    { value: 0, name: 'No or not sure' },
  ]

  operatingProductionProcess: Dropdowns[] = [
    { value: 2, name: 'I have one and it`s stable and consistent' },
    { value: 1, name: 'I have one but it`s not stable or consistent' },
    { value: 0, name: 'I haven`t identified one yet' },
  ]

  operatingSOP: Dropdowns[] = [
    { value: 2, name: 'Yes' },
    { value: 1, name: 'Yes, but it needs to be updated' },
    { value: 0, name: 'No or not sure' },
  ]

  teamHiring = [
    { name: 'Yes' },
    { name: 'No or not right now' },
  ]
  displayedColumns: string[] = ['name', 'doesNotExist', 'NeedsWork', 'GoodtoGo'];
  hrEmployeeRetention: Dropdowns[]=[
    { value: 1, name: 'Competitive Wages' },
    { value: 1, name: '401K and insurance benefits' },
    { value: 1, name: 'Company lunches, gatherings or outings' },
    { value: 1, name: 'Friendly onboarding process' },
    { value: 1, name: 'Company swag' },
    { value: 1, name: 'Commuter benefit' },
    { value: 1, name: 'Morally supportive environment' },
    { value: 1, name: 'Continuing Education supplementation/sponsorship' },
    { value: 1, name: 'Bonuses' },
    { value: 1, name: 'Other' },
  ]
  


  boolAnswer = [
  { name: 'Yes' }, 
  { name: 'No' }];
  // by @leonkoech
     // created a permanent storage for dropdowns.
     // original should be used as final Value
     // @talphysust should edit values
   teamRoleFull: Dropdowns[] = [
     { value: 1, name: 'Administration and operations' },
     { value: 1, name: 'Research and development, and Production' },
     { value: 1, name: 'Technical Assistance (Trades)' },
     { value: 1, name: 'Sales and marketing' },
     { value: 1, name: 'Accounting and finance' },
   ];
 
   teamRole= this.teamRoleFull;
 
   teamIndustryKnowledge: Dropdowns[] = [
     { value: 5, name: 'Expert' },
     { value: 4, name: 'Advanced' },
     { value: 3, name: 'Competent' },
     { value: 2, name: 'Developing' },
     { value: 1, name: 'Beginner' },
   ];
   teamTime: Dropdowns[] = [
     { value: 1, name: '8 hours or less' },
     { value: 2, name: '9-16 hours' },
     { value: 3, name: '17-24 hours' },
     { value: 4, name: '25-32 hours' },
     { value: 5, name: '33-40 hours or more' },
   ];
   teamNetwork: Dropdowns[] = [
     { value: 5, name: 'A great deal' },
     { value: 3, name: 'Moderately' },
     { value: 1, name: 'Not at all' },
   ];
   teamTimeManage: Dropdowns[] = [
     { value: 5, name: 'Extremely Well' },
     { value: 3, name: 'Moderately Well' },
     { value: 1, name: 'Not at all Well' },
   ];
   teamUnproductivity: Dropdowns[] = [
     { value: 1, name: 'Always or often' },
     { value: 3, name: 'Sometimes' },
     { value: 5, name: 'Rarely or never' },
   ];
   teamPassion: Dropdowns[] = [
     { value: 5, name: 'Extremely passionate' },
     { value: 3, name: 'Moderately passionate' },
     { value: 1, name: 'Not at all passionate' },
   ];

   teamWorkLife: Dropdowns[] = [
    { value: 5, name: 'Extremely well' },
    { value: 3, name: 'Moderately well' },
    { value: 1, name: 'Not well or does not exist' },
  ];
  
   noneAbove : Dropdowns[]= [
     {value: 0, name: "None of the above"}
   ]
 


  selection: any;
 

  //other one...didn't add get and set, or reset in this one
  
  
  @ViewChild('B2B') b2b: ElementRef;
  @ViewChild('B2C') b2c: ElementRef;
  @ViewChild('IndustryBarriers') industryBarriersOvercomeQ: ElementRef;
  @ViewChild('GeneralIndustryBarriers') generalIndustryBarriersQ: ElementRef;
  @ViewChild('CustomerService') customerServiceQ: ElementRef;
  @ViewChild('CustomerEngagement') customerEngagementQ: ElementRef;
  @ViewChild('OperatingAgreement') operatingAgreement: ElementRef;
  @ViewChild('OperatingProductionProcess') operatingProductionProcessQ: ElementRef;
  @ViewChild('TeamHiring') teamHiringQ: ElementRef;
  @ViewChild('HRRetention') hrRet: ElementRef;
  @ViewChild('HRHiringPractices') hrHP: ElementRef;
  
  
 

  constructor(
    private fb: FormBuilder,
    public fireBusinessAssessment: FireBusinessAssessmentService, //data in the other one
    private router: Router,
    public toastr: ToastrService,  // Toastr service for alert message
    public matDialog: MatDialog,
    public modal: ModalsService,
    public tooltip: MatTooltipModule,
    public fireActionItem: FireActionItemService,
  ) { }


  public teamMembersQuanCheck : number;
  public teamMemberHTMLVar: boolean = true;
  businessAssessmentID: any;
  
  public showAll: boolean = false;
  public buttonShow: boolean = true;
  public showBusiness: boolean = false;

  toggleStart() {
    this.buttonShow = !this.buttonShow;
    this.showBusiness = !this.showBusiness;
    this.showAll = !this.showAll;
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
   this.pmfSolveTest(this.generalBarriersNameArray,this.barriersOvercomeNameArray);
    this.fireBusinessAssessment.readAssessmentsList();  // Call ReadAssessmentsList() before main form is being called
    this.assessmenForm();              // Call assessment form when component is ready
    this.fillOfferIndustry();
  }



  // tslint:disable-next-line:typedef
  assessmenForm() {

    this.assessmentForm = this.fb.group({
      busiName: [null, Validators.required],
      busiFirstName: [null, Validators.required],
      busiLastName: [null, Validators.required],
      busiEmail: [null, Validators.required],
      busiTelephone: [null, Validators.required],
      offerType: [null, Validators.required],
      offerIndustry: [null, Validators.required],
      offerIndustrySubcategory: [null, Validators.required],
      operationsMethods: [null, Validators.required],      
      capitalSeeking: [null, Validators.required],      
      busiPlanArray: this.fb.group({
        busiPlanExecSum: [null, Validators.required],
        busiPlanMisVisGoal: [null, Validators.required],
        busiPlanBusiSum: [null, Validators.required],
        busiPlanOfferDescrip: [null, Validators.required],
        busiPlanIndustryOverview: [null, Validators.required],
        busiPlanTargetMarket: [null, Validators.required],
        busiPlanMarketingSummary: [null, Validators.required],
        busiPlanSaleStrategy: [null, Validators.required],
        busiPlanTeamOverview: [null, Validators.required],
        busiPlanFinancialProjections: [null, Validators.required],
      }),
      offerDifferentiation: [null, Validators.required],
      offerSupplierPower: [null, Validators.required],
      knownCompetition: [null, Validators.required],
      industryBarriersOvercome: null,
      generalIndustryBarriers: null,
      generalBarriersOvercome: null,
      marketTargetB2BC: [null, Validators.required],
      B2CTargetMarket: [null, Validators.required],
      B2BTargetMarket: [null, Validators.required],
      pmfCompetitorDissatisfaction: [null, Validators.required],
      //pmfB2BCompetitorDissatisfaction: [null, Validators.required],
     // pmfB2CCompetitorDissatisfaction: [null, Validators.required],
      marketingWebsite: null, 
      marketingBrand: null,
      marketingEffectiveness: null,
      marketingNetworkMaterial: null,
      marketingSocialMedia: null,
      customerEngagement: null,
      customerService: null,
      busiRegType: [null, Validators.required],
      legalOpAgreement: null,
      legalDisclaimers: null,
      legalIP: null,
      financePaymentSystem: null,
      financeAccountingSystem: null,
      operatingSOP: null,
      operatingProductionProcess: null,
      teamMembersQuan: [null, Validators.required],
      teamLeaderSerialEntrp: [null, Validators.required],
      teamRole: [null, Validators.required],
      teamIndustryKnowledge: [null, Validators.required],
      teamTime: [null, Validators.required],
      teamNetwork: [null, Validators.required],
      teamTimeManage: [null, Validators.required],
      teamUnproductivity: [null, Validators.required],
      teamPassion: [null, Validators.required],
      teamWorkLife:[null, Validators.required], 
      teamHiring: null,
      hrEmployeeRetention: null,
      hiringPractices: this.fb.group({
        hiringPracticesInterviewing: null,
        hiringPracticesJobDescrp: null,
        hiringPracticesOnboarding: null,
        hiringPracticesHR: null,
      }),
      
      
    });
  }

  ResetForm() { //add void as in other one?
    this.assessmentForm.reset();
  }



  onSubmit() {
    debugger
    const assessmentID = this.fireBusinessAssessment.createAssessment({ ...this.assessmentForm.value, industryBarriers: this.industryBarriersFull})
      .then((id) => {
        console.log(id +"id")
        this.businessAssessmentID = id;
    console.log("businessAssessmentID", id);
    this.fireBusinessAssessment.readSustainibleAssessment(this.businessAssessmentID);
      this.router.navigate(['business-assessment-results/', this.businessAssessmentID]);
      }).catch((e) => {
        console.log("error", e);
      }); // Submit data using CRUD API//take out value? 
  }

  update(){
    console.log("Update function", this.businessAssessmentID);
    this.fireBusinessAssessment.updateSustainibleeAssessment(this.businessAssessmentID, this.assessmentForm.value);
    this.fireBusinessAssessment.readSustainibleAssessment(this.businessAssessmentID);
  }

  updateRedirect(){//not using
    console.log("Update function 2", this.businessAssessmentID);
    this.fireBusinessAssessment.updateSustainibleeAssessment(this.businessAssessmentID, this.assessmentForm.value);
    this.fireBusinessAssessment.readSustainibleAssessment(this.businessAssessmentID);
    //this.ResetForm();
    this.router.navigate(['business-assessment-results', this.businessAssessmentID]);
  }

 
  tabNum = 0;

  nextTab() {
    if(this.tabNum < 5) {
      this.tabNum++;
    }
  }
  prevTab() {
    if(this.tabNum > 0) {
      this.tabNum--;
    }
  }

 

  fillOfferIndustry(){
    //fills the offerIndustry List with all Industry Names in json list
    //by @talpha
    debugger
       for(this.industryCategory in data) {
         this.allIndustryObjects = data[this.industryCategory];
         for(let i = 0; i < this.allIndustryObjects.length; i++) {
              this.offerIndustryFull.push({name: this.allIndustryObjects[i].industryCategory.name });
              console.log("IndustryCategoryName: " + this.offerIndustryFull[i].name);
         }
     }
    }

    handleIndustrySubcategories(event: { isUserInput: any; },nm: string, bool: boolean) {
      //  by @talpha
      //  function listens to changes in value of "industry name" and pushes subcategory values 
      if (event.isUserInput) {
        debugger
        this.offerIndustrySubcategoryFull = [];
        for(this.industryCategory in data) {
          this.allIndustryObjects = data[this.industryCategory];
        for(let y = 0; y < this.allIndustryObjects.length; y++) {
              if (nm === this.allIndustryObjects[y].industryCategory.name){
                this.singleIndustryObject = this.allIndustryObjects[y].industryCategory;
                console.log("Industry Cat Name: ", this.allIndustryObjects[y].industryCategory.name )
                for(let i = 0; i < this.singleIndustryObject.industrySubCategories.length; i++ ){
                  this.offerIndustrySubcategoryFull.push ({name: this.singleIndustryObject.industrySubCategories[i].name })
                  console.log("Industry Subcat Names: " + this.offerIndustrySubcategoryFull[i].name);
                }
              }
            }
          }
      }
    }
    

  handleIndustryBarriers(event: { isUserInput: any; }, nm: string, bool: boolean) {
    
    if (event.isUserInput) {
      debugger
      //find a way to stop the loop..the function is pushing the data into array but it doesnt stay
      for(this.industryCategory in data) {
        this.industryBarriersFull=[];
        this.industryBarriersOvercomeFull = [];
      for(let y = 0; y < this.singleIndustryObject.industrySubCategories.length; y++) {
            if (nm === this.singleIndustryObject.industrySubCategories[y].name){
              this.singleIndustrySubCatObject =  this.singleIndustryObject.industrySubCategories[y];
              for(let i = 0; i <this.singleIndustrySubCatObject.barriers.length; i++ ){
                this.industryBarriersFull.push({value: 1, name: this.singleIndustrySubCatObject.barriers[i] })
                this.industryBarriersOvercomeFull.push ({value: 1, name: this.singleIndustrySubCatObject.barriers[i] })
                console.log("Industry Subcat Barrier Names: " + this.industryBarriersOvercomeFull[i].name);
              }
            }
          }
      if(nm !== "Other"){//TODO only triggers if sub-cat "other" is selected, should trigger when cat "other" is selected 
        // then show the normal industry barriers question
        this.generalIndustryBarriersQ.nativeElement.style.display = 'none';
        this.industryBarriersOvercomeQ.nativeElement.style.display = 'block';
        } else {
          this.generalIndustryBarriersQ.nativeElement.style.display = 'block';
          this.industryBarriersOvercomeQ.nativeElement.style.display = 'none';
        }
      }
  }
  }

  selectChange(event: { isUserInput: any; },val:any, nm: string, bool: boolean) {
    //  edited by @leonkoech
    //  function listent to changes in value of "product Information">Question 8 and saves them to the value of
    if (event.isUserInput) {
      //if val is 0 then none of the above is selected
      if(val==0){
        // debugger
        if(bool){ this.selectedOption=[];
          this.selectedOption.push(nm)
          this.generalBarriersOvercomeFull=[];
          this.isNoneSelected(28);    
        }
      }
      else{        
        if (this.selectedOption.find(element => element === nm) === undefined) {
          this.selectedOption.push(nm);
          this.generalBarriersOvercomeFull.push({ "value": val, "name": nm });
        }
        else {
          this.generalBarriersOvercomeTemp = this.generalBarriersOvercomeFull.filter(function (opt) {
            return opt.name !== nm;
          });
          let updated = [];
          for (let el of this.selectedOption) {
            if (el !== nm) {
              updated.push(el);
            }
          }
          this.selectedOption = updated;
          this.generalBarriersOvercomeFull = this.generalBarriersOvercomeTemp;
          this.generalBarriersOvercome = this.generalBarriersOvercomeFull;
        }

      }
      this.isNonePI8=bool;
    }
  }
  
  


  isNoneSelected(page) {
    // by @leonkoech 
    // purpose: function handles "none of the above" for BusinessInformation Page
    switch (page) {
        // Product Information
        // 6
      case 26:
        this.isNonePI6 = !this.isNonePI6;
        resetController(this.isNonePI6,this.assessmentForm.controls.offerDifferentiation,this.offerDifferentiation,this.offerDifferentiationFull,this.noneAbove);
        break;
      // market Information
       // 8
       case 28:
        this.isNonePI8 = !this.isNonePI8;
        resetController(this.isNonePI8,this.assessmentForm.controls.offerMarkEntry,this.generalIndustryBarriers,this.generalIndustryBarriersFull,this.noneAbove);
         break;
      //
         case 24:
        this.isNoneI1 = !this.isNoneI1;
        resetController(this.isNoneI1,this.assessmentForm.controls.industryBarriersOvercome,this.industryBarriersOvercome,this.industryBarriersOvercomeFull,this.noneAbove);
        break;
    //11
      case 20:
        this.isNoneMI7 = !this.isNoneMI7;
        resetController(this.isNoneMI7,this.assessmentForm.controls.pmfCompetitorDissatisfaction,this.pmfCompetitorDissatisfaction,this.pmfCompetitorDissatisfactionFull,this.noneAbove);
        break;
      //10
     /* case 38:
        this.isNoneMI8 = !this.isNoneMI8;
        resetController(this.isNoneMI8,this.assessmentForm.controls.pmfCompetitorB2BDissatisfaction,this.pmfB2BCompetitorDissatisfaction,this.pmfB2BCompetitorDissatisfactionFull,this.noneAbove);
        break;
        //9
        case 39:
          this.isNoneMI11 = !this.isNoneMI11;
          resetController(this.isNoneMI8,this.assessmentForm.controls.pmfCompetitorB2CDissatisfaction,this.pmfB2CCompetitorDissatisfaction,this.pmfB2CCompetitorDissatisfactionFull,this.noneAbove);
          break;*/
        //B2BTM
        case 40:
            this.isNoneB2BTM = !this.isNoneB2BTM;
            resetController(this.isNoneB2BTM,this.assessmentForm.controls.B2BTargetMarket,this.B2BTargetMarket,this.B2BTargetMarketFull,this.noneAbove);
            break;
        //B2CTM
        case 41:
          this.isNoneB2CTM = !this.isNoneB2CTM;
          resetController(this.isNoneB2CTM,this.assessmentForm.controls.B2CTargetMarket,this.B2CTargetMarket,this.B2CTargetMarketFull,this.noneAbove);
          break;
     //Team Information
     //2
      case  42:
        this.isNoneT2=!this.isNoneT2;
        resetController(this.isNoneT2,this.assessmentForm.controls.teamRole,this.teamRole,this.teamRoleFull,this.noneAbove);
            break;  
      //7        
      case 47:
        this.isNoneTI7=!this.isNoneTI7;
        resetController(this.isNoneTI7,this.assessmentForm.controls.generalBarriersOvercome,this.generalBarriersOvercome,this.generalBarriersOvercome,this.noneAbove);
          break;  
      default:
        console.log("ee=")
        break;
    }
  }
   
  handleB2BC(event: { isUserInput: any; }, name: string) {
    if (event.isUserInput) {
      if (name === 'Business to Business') {
        this.b2b.nativeElement.style.display = 'block';
        this.b2c.nativeElement.style.display = 'none';
      }
      else if (name === 'Business to Consumer') {
        this.b2c.nativeElement.style.display = 'block';
        this.b2b.nativeElement.style.display = 'none';
      }
      else if (name === 'Both') {
        this.b2c.nativeElement.style.display = 'block';
        this.b2b.nativeElement.style.display = 'block';
      }
    }

  }

  handleOperatingAgreement(event: { isUserInput: any; }, name: string) {
    if (event.isUserInput) {
      if (name === 'Not registered' || name === 'Sole proprietor' || name === 'Single Member LLC' ) {
        this.operatingAgreement.nativeElement.style.display = 'none';
      }
      else if (name !== 'Not registered' || 'Sole proprietor' || 'Single Member LLC' ) {
        this.operatingAgreement.nativeElement.style.display = 'block';
       
      }
    }
  }

  handleProductServiceQuestions(event: { isUserInput: any; }, name: string) {
    debugger
    if (event.isUserInput) {
      if (name === 'Product') {
        this.operatingProductionProcessQ.nativeElement.style.display = 'block';
        this.customerEngagementQ.nativeElement.style.display = 'block';
        this.customerServiceQ.nativeElement.style.display = 'none';
      }
      else if (name === 'Product and Service' ) {
        this.operatingProductionProcessQ.nativeElement.style.display = 'block';
        this.customerServiceQ.nativeElement.style.display = 'block';
        this.customerEngagementQ.nativeElement.style.display = 'block';
       
      }
      else if (name === 'Service' ) {
        this.operatingProductionProcessQ.nativeElement.style.display = 'none';
        this.customerEngagementQ.nativeElement.style.display = 'none';
        this.customerServiceQ.nativeElement.style.display = 'block';
      }
    }

  }

//handles if single team member

  handleTeamQuanQuestions() {
    debugger
    if(this.teamMembersQuanCheck == 1) {
      this.teamHiringQ.nativeElement.style.display = 'block';
      this.hrRet.nativeElement.style.display = 'none';
      this.hrHP.nativeElement.style.display = 'none';
    } else {
      this.teamHiringQ.nativeElement.style.display = 'none';
      this.hrRet.nativeElement.style.display = 'block';
      this.hrHP.nativeElement.style.display = 'block';
    }
  }


  handleHiringQuestions(event: { isUserInput: any; }, name: string) {
   debugger
    if (event.isUserInput) {
      if (name === 'Yes') {
        this.hrHP.nativeElement.style.display = 'block';
      }else {
        this.hrHP.nativeElement.style.display = 'none';
    }
  }
}
  generalBarriersNameArray =  [
  {name: "ok", value: 1},
  {name: "no", value: 3},
  {name: "wow", value: 2},
  {name: "wow2", value: 2},
];

 barriersOvercomeNameArray = [
  {name: "wow2", value: 2},
  {name: "no", value: 3},
  ]

pmfSolveTest(array1, array2 ){ //gets the same name
  debugger
  let sameNameArray: any = [];
  let notSameNameArray: any=[];
  sameNameArray = array1.reduce(x => array2.map(y => y.name).includes(x.name));
 // notSameNameArray = array1.filter(x=> !array2.map(y => y.name).includes(x.name));
  return  sameNameArray;
}



}
